import React, { Component } from "react";
import history from "../../../../history";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import { CONFIG, URL_AKM } from "../../../../config";
import akmApi from "../../../../apis/akmApi";
import accountManagement from "../../../../apis/accountManagement";
import __ from "lodash";
import { Container, Card, Button, Fade, Row, Col, Alert, Form } from "react-bootstrap";
import Switch from "@material-ui/core/Switch";
import LoaderModal from "../../../modal/LoaderModal";
import Loader from "../../../Loader";
import DropdownUploadHistory from "../masterDropDown/DropdownUploadHistory";
import ArraySoal from "../../../../entity/ArraySoal";
import FilterSoal from "../../../../entity/FilterSoal";
import PaginationData from "../../../../entity/PaginationData";
import PaginationTable from "../masterDropDown/PaginationTable";
import style from "./custom-soal.css";
import axios from "axios";
import { TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

class AkmSoal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profilCbt: this.props.location.state.profil,
      subProfil: this.props.location.state.subProfil,
      uploadHis: [],
      listSoal: [],
      soalSelected: [],
      isFetching: false,
      open: false,
      showAlert: false,
      resMessage: {},
      filterSoalSeach: FilterSoal,
      paginationData: PaginationData,
      countSoalSelected: 0,
    };
  }

  async componentDidMount() {
    await this.props.cekCookies();
    this.setState({
      filterSoalSeach: { idMataPelajaran: this.props.location.state.subProfil.idMataPelajaran },
    });
    this.fetchUploadHis();
    this.fetchExamSoal(this.props.location.state.subProfil.idSubProfilCbt);
    this.fetchSoal();
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      //script.src = "./Mathjax-2.7.5/MathJax.js?config=TeX-MML-AM_HTMLorMML";
      script.src = "https://s3edubucket.s3-ap-southeast-1.amazonaws.com/javascripts/MathJax-2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";

      var config = "MathJax.Hub.Config({" + 'extensions: ["tex2jax.js"],' + 'jax: ["input/TeX","output/HTML-CSS"]' + "});" + "MathJax.Hub.Startup.onload();";

      if (window.opera) {
        script.innerHTML = config;
      } else {
        script.text = config;
      }

      script.addEventListener("load", function () {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ""]);
      });

      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  }

  async fetchUploadHis() {
    const result = await akmApi.post(URL_AKM.POST_UPLOAD_HISTORY_ID, { idAdmin: this.props.account.idAdmin }).catch(function (error) {
      console.log(error);
    });

    if (result) {
      let uploadHistory = [];
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        uploadHistory = result.data.data;
      }
      this.setState({ uploadHis: uploadHistory });
    }
  }

  renderUploadHis = () => {
    const { uploadHis } = this.state;
    if (uploadHis !== null) {
      return <DropdownUploadHistory uploadHis={uploadHis} />;
    }
  };

  fetchExamSoal = async (id) => {
    this.setState({ isFetching: true });
    const result = await accountManagement.get(CONFIG.EXAM_SOAL_GET + id).catch(function (error) {
      console.log(error);
    });

    if (result) {
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          soalSelected: result.data.data,
          open: false,
        });
      }

      const res = await akmApi.get(URL_AKM.GET_JUMLAH_SOAL_AKM + id).catch(function (error) {
        console.log(error);
      });
      if (res) {
        if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          this.setState({ countSoalSelected: res.data.data });
        }
      }
    }
    this.setState({ isFetching: false });
  };

  fetchSoal = async () => {
    this.setState({ isFetching: true });
    const result = await akmApi.post(URL_AKM.BANK_SOAL_LIST, this.state.filterSoalSeach, { params: { page: this.state.paginationData.page, size: this.state.paginationData.size } });
    if (result) {
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listSoal: result.data.data.content,
          paginationData: {
            ...this.state.paginationData,
            page: result.data.data.number,
            size: result.data.data.size,
            totalPages: result.data.data.totalPages,
            numberOfElements: result.data.data.numberOfElements,
            totalElements: result.data.data.totalElements,
          },
        });
      } else {
        this.setState({
          listSoal: [],
          paginationData: PaginationData,
          showAlert: true,
          resMessage: result.data.errorSchema.errorMessage,
        });
      }
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ""]);
      this.setState({ isFetching: false });
    }
  };

  filterSoal = () => {
    const { open, subProfil, uploadHis } = this.state;
    return (
      <>
        <Row>
          <Col>
            <h3>Soal AKM: {subProfil.namaMapel}</h3>
          </Col>
          <Col>
            <Button variant="outline-dark" style={{ width: "100%" }} onClick={() => this.setState({ open: !open })} aria-controls="example-fade-text" aria-expanded={open}>
              {" "}
              Open Soal
            </Button>
          </Col>
          <Col>
            <Button
              variant="outline-danger pull-right"
              onClick={() => {
                if (window.confirm("Konfirmasi Keluar ?")) this.handleBack();
              }}
            >
              Keluar <i className="fa fa-arrow-right"></i>
            </Button>
          </Col>
        </Row>
        {open ? (
          <Fade in={open}>
            <Card style={{ marginTop: "10px" }}>
              <Card.Body>
                <Row>
                  <Col sm={6}>
                    <div className="form-group">
                      {/* <label htmlFor="upload">Upload History :</label>
                      <select className="form-control" name="upload" id="upload" value={this.state.filterSoalSeach.idUploadHistory || ""} onChange={this.handleChangeUpHis}>
                        <option value="">Pilih Upload History...</option>
                        {this.renderUploadHis()}
                      </select> */}
                      <Autocomplete
                        id="idUploadHistory"
                        size="small"
                        onChange={this.handleAutoComplete}
                        disableClearable={true}
                        options={uploadHis}
                        getOptionLabel={(uphis) => uphis.keterangan}
                        // renderInput={(params) => <TextField {...params} label="Pilih Upload History gan" variant="outlined" />}
                        renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Cari Upload History"
                          variant="outlined"
                          onChange={(e) => this.fetchUploadHistory(e)}
                        />
                      )}
                      />
                    </div>
                  </Col>
                </Row>

                <div>
                  <Button
                    variant="outline-dark btn-lg"
                    onClick={() => {
                      this.btnTampil();
                    }}
                  >
                    Tampilkan Soal
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Fade>
        ) : (
          ""
        )}
      </>
    );
  };

  handleAutoComplete = async (event, value, reason) => {
    const id = event.target.id;
    const idSplit = id.split("-");
    if (!value.idUploadHistory) {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, [[idSplit[0]]]: null, idMataPelajaran: this.state.subProfil.idMataPelajaran } });
    } else {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, [[idSplit[0]]]: value.idUploadHistory, idMataPelajaran: null } });
    }
  };

  fetchUploadHistory = async (keterangan) => {
    var value = keterangan.target.value
    if (value && value.length >= 5) {
      await akmApi
      .post(URL_AKM.POST_UPLOAD_HISTORY_ID, {
        idAdmin: this.props.account.idAdmin,
        keterangan: value,
      })
      .then((response) => {
        if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
          this.setState({ uploadHis: response.data.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  };

  setLevelSoal(tipe, kode) {
    let string = "-";
    if (kode === "1") {
      string = "Mudah";
    }
    if (kode === "2") {
      string = "Sedang";
    }
    if (kode === "3") {
      string = "Sulit";
    }
    if (kode === "4") {
      string = "Sgt Sulit";
    }
    if (kode === "5") {
      string = "Sgt Mudah";
    }
    return tipe + "/" + string;
  }

  fetchSoalAkmDetail = async (idBankSoal) => {
    const response = await akmApi.get(URL_AKM.GET_SOAL_DETAIL_AKM_BY_IDBANKSOAL + idBankSoal).catch(function (error) {
      console.log(error);
    });

    if (response) {
      console.log("res", response.data.data);
      if (response.data.data === null) {
        let count = this.state.countSoalSelected;
        this.setState({ countSoalSelected: count + 1 });
      }
    }

    return 3;
  };

  renderSoal = () => {
    const { open, paginationData, listSoal, soalSelected } = this.state;
    const scroll = {
      overflow: "auto",
    };

    let nomorSoal = paginationData.size * paginationData.page + 1;
    if (!open) {
      return (
        <Row style={{ marginTop: "10px" }}>
          <Col sm={12} style={{ marginBottom: "30px" }}>
            <div className="tab-content">
              <table className="table">
                <tbody>
                  {listSoal.map((soal, i) => (
                    <tr key={i}>
                      <td width="10px">
                        <p>{nomorSoal++}.</p>
                      </td>
                      <td>
                        <div className="floating-label-head">
                          <div className="floating-label">{this.setLevelSoal(soal.tipeSoal, soal.mudahSulit)}</div>
                        </div>
                        <div id="accordion">
                          <span dangerouslySetInnerHTML={{ __html: soal.pertanyaan }}></span>
                          <span className="text-primary text-detail" data-toggle="collapse" href={"#soal" + soal.idBankSoal} aria-expanded="true" style={{ cursor: "pointer" }}>
                            details..
                          </span>
                          <div id={"soal" + soal.idBankSoal} className="collapse" data-parent="#accordion">
                            <table className="table">
                              <tbody>
                                <tr style={{ backgroundColor: soal.kunciJawaban == "1" ? "#d7fadd" : "" }}>
                                  <td width="10px">
                                    <p>A.</p>
                                  </td>
                                  <td dangerouslySetInnerHTML={{ __html: soal.jawab1 }}></td>
                                </tr>
                                <tr style={{ backgroundColor: soal.kunciJawaban == "2" ? "#d7fadd" : "" }}>
                                  <td>
                                    <p>B.</p>
                                  </td>
                                  <td dangerouslySetInnerHTML={{ __html: soal.jawab2 }}></td>
                                </tr>
                                <tr style={{ backgroundColor: soal.kunciJawaban == "3" ? "#d7fadd" : "" }}>
                                  <td>
                                    <p>C.</p>
                                  </td>
                                  <td dangerouslySetInnerHTML={{ __html: soal.jawab3 }}></td>
                                </tr>
                                <tr style={{ backgroundColor: soal.kunciJawaban == "4" ? "#d7fadd" : "" }}>
                                  <td>
                                    <p>D.</p>
                                  </td>
                                  <td dangerouslySetInnerHTML={{ __html: soal.jawab4 }}></td>
                                </tr>
                                <tr style={{ backgroundColor: soal.kunciJawaban == "5" ? "#d7fadd" : "" }}>
                                  <td>
                                    <p>E.</p>
                                  </td>
                                  <td dangerouslySetInnerHTML={{ __html: soal.jawab5 }}></td>
                                </tr>
                                <tr>
                                  <td colSpan={2}>
                                    <p>Bobot Soal:</p>
                                    <span>{this.renderBobot(soal.mudahSulit)}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2}>
                                    <p>Pembahasan:</p>
                                    <span dangerouslySetInnerHTML={{ __html: soal.isianJawaban }}></span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                      <td width="10px">
                        <Switch
                          color="secondary"
                          value={soal.idBankSoal}
                          onChange={(e) => this.handleChange(e)}
                          checked={soalSelected.find((val) => (val.idBankSoal == soal.idBankSoal ? true : false))}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <PaginationTable paging={this.state.paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
            </div>
          </Col>

          <Col sm={12}>
            <div>
              <Card>
                <Card.Header>Soal Selected: {this.state.countSoalSelected}</Card.Header>
                <div style={scroll}>
                  <table className="table">
                    <tbody id="cek">
                      {soalSelected.map((sol, i) => (
                        <tr key={sol.idBankSoal}>
                          <td>
                            <p>{i + 1}.</p>
                          </td>

                          <td>
                            <span dangerouslySetInnerHTML={{ __html: sol.pertanyaan }}></span>
                          </td>
                          <td>
                            <button className="btn btn-danger btn-sm" onClick={() => this.rmvSoalSelected(sol.idBankSoal)}>
                              <i className="fa fa-remove" aria-hidden="true"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card>

              <Col className="text-center" style={{ marginTop: "20px", marginBottom: "50px" }}>
                <input type="hidden" name="idProfilCbt" value={this.state.subProfil.idProfilCbt} />
                <input type="hidden" name="idSubProfilCbt" value={this.state.subProfil.idSubProfilCbt} />
                <input type="hidden" name="arraySoal" value={soalSelected.map((v) => v.idBankSoal)} />
                {soalSelected.length > 0 && (
                  <Button
                    variant="primary"
                    type="submit"
                    style={{ width: "100%" }}
                    onClick={() => {
                      if (window.confirm("Konfirmasi Simpan ?")) this.handleSubmit();
                    }}
                  >
                    Simpan <i className="fa fa-save"></i>
                  </Button>
                )}
              </Col>
            </div>
          </Col>
        </Row>
      );
    }
  };

  renderBobot(value) {
    if (value === "1") {
      return "Mudah";
    } else if (value === "2") {
      return "Sedang";
    } else if (value === "3") {
      return "Sulit";
    } else if (value === "4") {
      return "Sangat Sulit";
    } else {
      return "Sangat Mudah";
    }
  }

  handleChangePage = async (newPage) => {
    this.state.paginationData.page = newPage;
    this.fetchSoal();
  };

  handleChangeRowsPerPage = (size) => {
    this.state.paginationData.page = 0;
    this.state.paginationData.size = size;
    this.fetchSoal();
  };

  handleChangeUpHis = async (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, idUploadHistory: null, idMataPelajaran: this.state.subProfil.idMataPelajaran } });
    } else {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, idUploadHistory: value, idMataPelajaran: null } });
    }
  };

  btnTampil = async (e) => {
    this.setState({ showAlert: false, soals: [] });
    this.fetchSoal();
    this.setState({ open: false });
  };

  handleChange = async (e) => {
    let isChecked = e.target.checked;
    let value = e.target.value;
    const { listSoal, soalSelected } = this.state;
    let statuse = false;
    if (isChecked) {
      listSoal.map((soal) => {
        if (soal.idBankSoal == value) {
          this.setState((prevState) => ({
            soalSelected: [...prevState.soalSelected, soal],
          }));
        }
      });
      statuse = true;
    } else {
      this.setState({
        soalSelected: soalSelected.filter((v) => v.idBankSoal != value),
      });
    }

    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ""]);
    const res = await akmApi.get(URL_AKM.GET_JUMLAH_SOAL_AKM_BY_IDBANKSOAL + value).catch(function (error) {
      console.log(error);
    });
    if (res) {
      if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        if (statuse) {
          this.setState({ countSoalSelected: this.state.countSoalSelected + res.data.data });
        } else {
          this.setState({ countSoalSelected: this.state.countSoalSelected - res.data.data });
        }
      }
    }
  };

  rmvSoalSelected = async (id) => {
    this.setState({ soalSelected: this.state.soalSelected.filter((soal) => soal.idBankSoal !== id) });
    const res = await akmApi.get(URL_AKM.GET_JUMLAH_SOAL_AKM_BY_IDBANKSOAL + id).catch(function (error) {
      console.log(error);
    });
    if (res) {
      if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({ countSoalSelected: this.state.countSoalSelected - res.data.data });
      }
    }
  };

  handleSubmit = async () => {
    this.setState({ isFetching: true });
    const { subProfil, soalSelected } = this.state;

    const response = await accountManagement
      .post(CONFIG.EXAM_ADD_SOAL, { ...ArraySoal, ["idProfilCbt"]: subProfil.idProfilCbt, ["idSubProfilCbt"]: subProfil.idSubProfilCbt, ["arraySoal"]: soalSelected.map((val) => val.idBankSoal) })
      .catch(function (error) {
        console.log(error);
      });

    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        const res = await akmApi.post(URL_AKM.POST_ADD_SUBPROFIL, { ...subProfil, jumlahSoal: this.state.countSoalSelected }).catch(function (error) {
          this.setState({ showAlert: true, resMessage: error });
        });
        if (res) {
          if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
            this.handleBack();
          }
        }
      } else {
        this.setState({
          showAlert: true,
          resMessage: response.data.errorSchema,
        });
        this.setState({ isFetching: false });
      }
    }
  };

  handleBack() {
    if (this.state.profilCbt.kodeSubTipeCbt === "AN") history.push({ pathname: "/akm", state: { profil: this.state.profilCbt } });
    if (this.state.profilCbt.kodeSubTipeCbt === "QUEST") history.push({ pathname: "/profil_qs", state: { profil: this.state.profilCbt } });
  }

  render() {
    return (
      <Container fluid style={{ marginTop: "20px" }}>
        <LoaderModal isFetching={this.state.isFetching} />
        {this.renderAlert()}
        {this.loading()}
        {this.filterSoal()}
        {this.renderSoal()}
      </Container>
    );
  }

  renderAlert = () => {
    const { showAlert, resMessage } = this.state;
    if (showAlert) {
      return (
        <Alert variant="info" onClose={() => this.setState({ showAlert: false })} dismissible>
          <strong>{resMessage}</strong>
        </Alert>
      );
    }
  };

  loading = () => {
    if (this.state.isSearch) {
      return <Loader />;
    }
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(AkmSoal);
